import "./index.css";
import React, { useEffect, useState } from "react";
import Firebase from "../../firebasehelper";
import AssignTokenContainer from "../AssignTokenContainer";

import PremierImg from "../../assets/media/coins/dollar-coin.png";
import ShoppingImg from "../../assets/media/coins/percent-coin.png";

export default function AddTokenLedgerModal({
  name: brandName,
  user,
  territory,
  total,
  hex,
  white,
  setCurrent,
  addTokens,
}) {
  const [hotTasks, setHotTasks] = useState([]);
  const [isAssignable, setAssignable] = useState(false);
  const [tokenPayload, setTokenPayload] = useState(null);
  const [isOpen, setOpen] = useState(true); // hack to reset values on close

  useEffect(() => {
    if (brandName) {
      Firebase.getAllHotTasks(brandName, (hotTaskIds) => {
        if (hotTaskIds && hotTaskIds.length) {
          Firebase.getAllTokenEarnings((res) => {
            const topTasks = res.filter((task) =>
              hotTaskIds.some((id) => id === task.id)
            );
            setHotTasks(topTasks);
          });
        }
      });
    }
  }, [brandName]);

  const handleChangeTokens = (payload) => {
    const { category, premierTokens, shoppingTokens, adminId } = payload;
    const isValid = category && (premierTokens || shoppingTokens);

    setAssignable(isValid);
    setTokenPayload(payload);
  };

  // This is a hack to reset token input by re-rendering AssignTokenContainer
  const resetAddTokenInput = () => {
    setTimeout(() => {
      setOpen(false);
      setOpen(true);
    }, 800);
  };

  return (
    <div
      className="modal fade"
      id="add_user_token_ledgers"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="false"
      data-backdrop="false"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Assign tokens to {user.firstname}</h5>
            <button
              type="button"
              className="btn btn-sm btn-white btn-brand-hex"
              data-dismiss="modal"
              onClick={() => {
                setCurrent("user");
                resetAddTokenInput();
              }}
              style={{
                "--hover-text-color": white ? "white" : "black",
                "--hover-color": hex,
                backgroundColor: "white",
                color: "black",
              }}
            >
              Back to ledger
            </button>
          </div>
          {isOpen && (
            <div className="modal-body pb-1">
              <AssignTokenContainer
                tokenTasks={hotTasks}
                territory={territory}
                onChange={handleChangeTokens}
                brandName={brandName}
                hex={hex}
                white={white}
              />
            </div>
          )}
          <div className="modal-footer">
            <img
              src={ShoppingImg}
              style={{ width: "35px" }}
              alt="shopping tokens"
            />
            <p>{`${total.shopping_total <= 0 ? "+" : "-"} ${Math.abs(
              total.shopping_total
            )}`}</p>
            <img
              src={PremierImg}
              style={{ width: "35px" }}
              alt="premier tokens"
            />
            <p style={{ marginRight: "auto" }}>{`${
              total.premier_total <= 0 ? "+" : "-"
            } ${Math.abs(total.premier_total)}`}</p>
            <button
              type="button"
              className="btn btn-sm btn-green"
              data-dismiss="modal"
              disabled={!isAssignable}
              onClick={() => {
                addTokens(tokenPayload);
                setCurrent("user");
                resetAddTokenInput();
              }}
            >
              Add tokens
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/AddTokenLedgerModal/index.js